(function ($) {
  $(document).ready(function () {
    var $body = $("body");
    var $header = $("#header");
    var $menu = $("#header-menu-container");
    var $overlay = $("#header_menu_sf");

    var isOpen = false;

    // Search toggle
    $(".search-toggle").on("click", function () {
      const wrapper = $(".header-search");
      wrapper.toggleClass("active");
      const headerContentMain = $(".header-content-main");
      headerContentMain.toggleClass("search-active");
      $(this).attr("aria-expanded", wrapper.hasClass("active") ? "true" : "false");
      // autofocus when opened
      if (wrapper.hasClass("active")) {
        wrapper.find(".search-field").focus();
      }
    });

    // Close search when clicking outside
    $(document).on("click", function (e) {
      if (!$(e.target).closest(".header-search").length) {
        $(".header-search").removeClass("active");
        $(".header-content-main").removeClass("search-active");
        $(".search-toggle").attr("aria-expanded", "false");
      }
    });

    /* =========================
       HELPERS
    ========================= */
    var mobileQuery = window.matchMedia("(max-width: 991.98px)");
    function isMobile() {
      return mobileQuery.matches;
    }

    var $openBtn = $("#header-menu-open-btn");

    function openMenu() {
      if (isOpen) return;

      isOpen = true;
      $body.css("overflow", "hidden");
      $openBtn.attr("aria-expanded", "true");

      $overlay.fadeIn(150);
      $menu
        .show()
        .addClass("opened")
        .css({ top: "-100%", opacity: 0 })
        .animate({ top: 0, opacity: 1 }, 250, function () {
          $menu.find("#header-menu-mobile-close").focus();
        });
    }

    function closeMenu() {
      if (!isOpen) return;

      var returnFocus = $.contains($menu[0], document.activeElement);

      isOpen = false;
      $body.css("overflow", "");
      $openBtn.attr("aria-expanded", "false");

      $menu.animate({ top: "-100%", opacity: 0 }, 200, function () {
        $menu.removeClass("opened").hide();
      });

      $overlay.fadeOut(150);

      closeAllSubmenus();

      if (returnFocus) {
        $openBtn.focus();
      }
    }

    /* =========================
       SUBMENUS — shared by pointer and keyboard
    ========================= */
    function closeAllSubmenus() {
      $(".header-menu-secondary-item")
        .removeClass("selected")
        .addClass("unselected");
      $(".header-menu-secondary-parent-link").attr("aria-expanded", "false");
      $(".header-menu-secondary_subelem_cont").hide();
    }

    function openSubmenu($item) {
      if (!$item.length || $item.hasClass("selected")) return;

      closeAllSubmenus();

      var $panel = $item.children(".header-menu-secondary_subelem_cont");

      $item.removeClass("unselected").addClass("selected");
      $item.find(".header-menu-secondary-parent-link").attr("aria-expanded", "true");

      if (isMobile()) {
        $panel.css("top", "").slideDown(200);
      } else {
        // Anchor the fixed dropdown to the header's actual rendered bottom so
        // it always sits flush under the sticky header. getBoundingClientRect
        // accounts for the admin bar, current scroll, and responsive header
        // height, avoiding the intermittent gap from CSS `top: unset`.
        $panel.css({ display: "grid", top: $header[0].getBoundingClientRect().bottom + "px" });
      }
    }

    function closeSubmenu($item) {
      if (!$item.length) return;

      $item.removeClass("selected").addClass("unselected");
      $item.find(".header-menu-secondary-parent-link").attr("aria-expanded", "false");

      var $panel = $item.children(".header-menu-secondary_subelem_cont");
      if (isMobile()) {
        $panel.slideUp(200);
      } else {
        $panel.hide();
      }
    }

    var $withChild = $(".header-menu-secondary-item.header-menu-secondary-item_withchild");

    /* =========================
       OPEN BUTTONS
    ========================= */
    $("#header-menu-open-btn, #header-menu-open-btn_mobile").on(
      "click",
      function (e) {
        e.preventDefault();
        openMenu();
      },
    );

    /* =========================
       CLOSE BUTTON
    ========================= */
    $("#header-menu-mobile-close").on("click", function () {
      closeMenu();
    });

    /* =========================
       CLICK OUTSIDE (OVERLAY)
    ========================= */
    $overlay.on("click", function () {
      closeMenu();
    });

    /* =========================
       CLOSE ON CLICK OUTSIDE HEADER
    ========================= */
    $(document).on("click", function (e) {
      if (
        isOpen &&
        !$(e.target).closest("#header").length &&
        !$(e.target).closest("#header-menu-container").length
      ) {
        closeMenu();
      }
    });

    /* =========================
       CLOSE ON ANY LINK CLICK INSIDE MENU
    ========================= */
    $menu.on("click", "a", function () {
      closeMenu();
    });

    /* =========================
       DESKTOP HOVER SUBMENUS
    ========================= */
    $withChild.on("mouseenter", function () {
      if (isMobile()) return;
      $(this).removeData("escClosed");
      openSubmenu($(this));
    });

    /* =========================
       KEYBOARD SUBMENUS
       Focus opens the panel; Esc closes it; ArrowDown moves into it.
    ========================= */
    $withChild.on("focusin", function () {
      if (isMobile()) return;
      // Esc leaves focus on the parent link — don't reopen what it just closed.
      if ($(this).data("escClosed")) return;
      openSubmenu($(this));
    });

    $withChild.on("focusout", function (e) {
      var $item = $(this);
      if (e.relatedTarget && $.contains($item[0], e.relatedTarget)) return;
      $item.removeData("escClosed");
      closeSubmenu($item);
    });

    $withChild.on("keydown", function (e) {
      var $item = $(this);

      if (e.key === "Escape" && $item.hasClass("selected")) {
        e.stopPropagation();
        $item.data("escClosed", true);
        closeSubmenu($item);
        $item.find(".header-menu-secondary-parent-link").focus();
        return;
      }

      if (e.key === "ArrowDown") {
        e.preventDefault();
        $item.removeData("escClosed");
        openSubmenu($item);
        $item.find(".header-menu-secondary_subelem a").first().focus();
        return;
      }

      if (e.key === "ArrowUp" && $item.hasClass("selected")) {
        e.preventDefault();
        $item.data("escClosed", true);
        closeSubmenu($item);
        $item.find(".header-menu-secondary-parent-link").focus();
      }
    });

    /* =========================
       MOBILE TAP SUBMENUS
       Clicking the parent link navigates; clicking the label padding/chevron area toggles submenu
    ========================= */
    $withChild.on("click", function (e) {
      if (!isMobile()) return;

      // If the click was on the parent link, let it navigate — don't toggle submenu
      if ($(e.target).closest(".header-menu-secondary-parent-link").length) {
        return;
      }

      var $self = $(this);

      if ($self.hasClass("selected")) {
        closeSubmenu($self);
      } else {
        openSubmenu($self);
      }
    });

    /* =========================
       ESC KEY CLOSE
    ========================= */
    // keydown, so an open submenu can stopPropagation and take the first Esc
    $(document).on("keydown", function (e) {
      if (e.key === "Escape") {
        closeMenu();
      }
    });
  });
})(jQuery);
